import { useOutletContext } from "react-router";
import type { Membresia, Usuario } from "@/lib/api";
import type { EstadoPuestaEnMarcha } from "./useMenu";

/** Lo que toda pantalla logueada necesita: quién es, con qué rol y en qué fideicomiso. */
export interface ContextoApp {
  usuario: Usuario;
  membresia: Membresia;
  fid: number;
  /** Puesta en marcha del desarrollo (la pide `useMenu` sólo para el admin; el Inicio la reusa, sin pedirla de nuevo). */
  puestaEnMarcha: EstadoPuestaEnMarcha;
  /** Vuelve a pedir /api/auth/yo (ej. al empezar "Ver como fiduciante"). */
  recargarUsuario: () => Promise<void>;
}

export function useContextoApp(): ContextoApp {
  return useOutletContext<ContextoApp>();
}
